import { createFileRoute } from "@tanstack/react-router";
import HomepageContentManager from "@/pages/admin/HomepageContentManager";

export const Route = createFileRoute("/admin/homepage-content")({
  component: HomepageContentManager,
});
